<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
-->

<template>
  <div class="orangehrm-background-container">
    <oxd-text tag="h6" class="orangehrm-main-title expensa-title">
      {{ $t('expensa.menu_configuration') }}
    </oxd-text>
    <oxd-text v-if="loadFailed" tag="p">
      {{ $t('expensa.list_error') }}
    </oxd-text>
    <oxd-text v-else-if="!me" tag="p">
      {{ $t('expensa.loading') }}
    </oxd-text>
    <oxd-text v-else-if="!canView" tag="p">
      {{ $t('expensa.not_allowed') }}
    </oxd-text>
    <template v-else>
      <categories-section :can-write="canView" />
      <vehicles-section :can-write="canView" class="expensa-gap" />
      <settings-section :can-write="me.isAdmin" class="expensa-gap" />
      <finance-section v-if="me.isAdmin" class="expensa-gap" />
    </template>
  </div>
</template>

<script>
import CategoriesSection from '@/orangehrmExpensaPlugin/components/config/CategoriesSection.vue';
import FinanceSection from '@/orangehrmExpensaPlugin/components/config/FinanceSection.vue';
import SettingsSection from '@/orangehrmExpensaPlugin/components/config/SettingsSection.vue';
import VehiclesSection from '@/orangehrmExpensaPlugin/components/config/VehiclesSection.vue';
import {expensaApi} from '../util/api';

// Configurazione: sezioni una sotto l'altra (in @ohrm/oxd 2.0.3 c'è solo il
// contenitore di schede dei form, non schede di navigazione). Le sezioni
// visibili dipendono da `me`; i permessi veri li applica il server.
export default {
  name: 'ExpensaConfiguration',
  components: {
    'categories-section': CategoriesSection,
    'vehicles-section': VehiclesSection,
    'settings-section': SettingsSection,
    'finance-section': FinanceSection,
  },
  data() {
    return {
      me: null,
      loadFailed: false,
    };
  },
  computed: {
    canView() {
      return !!this.me && (this.me.isFinance || this.me.isAdmin);
    },
  },
  beforeMount() {
    expensaApi('/me')
      .getAll()
      .then(({data}) => {
        this.me = data.data;
      })
      .catch(() => {
        this.loadFailed = true;
      });
  },
};
</script>

<style scoped lang="scss">
.expensa-title {
  margin-bottom: 1rem;
}
.expensa-gap {
  margin-top: 1rem;
}
</style>
